






























































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import addTaskMixin from './addTaskMixin'
import BillApi from '@/api/bill2'

@Component({})
export default class MedicalRecord extends Mixins(addTaskMixin) {
	public onTaskAdd() {
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				if (!this.fileList.length) {
					return this.$message.error('请上传授权文件')
				}
				values.authorizeInfoId = this.fileId
				values.authorizeInfoName = this.picName

				this.addLoading = true
				BillApi.queryMedicalRecord(values)
					.then((res: any) => {
						this.orderId = res.data
						this.pollingAdd(
							{
								orderId: this.orderId,
								patientName: this.addForm.getFieldValue('patientName'),
								idCard: this.addForm.getFieldValue('idCard'),
							},
							() => {
								this.onFailOk()
							},
							() => {
								this.onOk()
							}
						)
					})
					.finally(() => {
						this.addLoading = false
					})
			}
		})
	}
}
